import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PageNotFound from "./pages/PageNotFound";
import Prawo from "./pages/Prawo";
import PozyczkiUnijne from "./pages/PozyczkiUnijne";
import PersonalMedia from "./pages/PersonalMedia";
import ONas from "./pages/ONas";
import Leasingi from "./pages/Leasingi";
import KredytyFirmowe from "./pages/KredytyFirmowe";
import KredytyHipoteczne from "./pages/KredytyHipoteczne";

function App() {
  return (
    <div className="bg-gray-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/*" element={<PageNotFound />} />
          <Route path="/onas" element={<ONas />} />
          <Route path="/prawo" element={<Prawo/>} />
          <Route path="/pozyczkiunijne" element={<PozyczkiUnijne/>} />
          <Route path="/personalmedia" element={<PersonalMedia />} />
          <Route path="/leasingi" element={<Leasingi />} />
          <Route path="/kredytyfirmowe" element={<KredytyFirmowe />} />
          <Route path="/kredytyhipoteczne" element={<KredytyHipoteczne />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
